import { PlatformCost, PlatformCostType } from '../types/platform-cost';

export const DEFAULT_PLATFORM_COSTS_CURRENCY = 'USD';

export const DEFAULT_SHOPIFY_PLATFORM_COSTS: PlatformCost[] = [
  { type: PlatformCostType.Percentage, value: 2, selected: true },
  { type: PlatformCostType.FixedAmount, value: 0.3 },
  { type: PlatformCostType.Mixed, value: 1.75, extraAmount: 0.3 },
];

export const DEFAULT_ETSY_PLATFORM_COSTS: PlatformCost[] = [
  { type: PlatformCostType.Percentage, value: 2, selected: true },
  { type: PlatformCostType.FixedAmount, value: 6.5 },
  { type: PlatformCostType.Mixed, value: 2, extraAmount: 6.5 },
];

export const DEFAULT_PLATFORM_COSTS: PlatformCost[] = [
  { type: PlatformCostType.Percentage, value: 0, selected: true },
  { type: PlatformCostType.FixedAmount, value: 0 },
  { type: PlatformCostType.Mixed, value: 0, extraAmount: 0 },
];
